module.exports = __webpack_public_path__ + "img/1440.91ef82d5.jpg";